import {createContext, useReducer} from "react";
import {notificationConfigListReducer} from "../state/notificationConfigListReducer";


export const NotificationConfigListContext = createContext([])

export const withNotificationConfigListContext = Component => {

    return props => {
        const [state, dispatch] = useReducer(notificationConfigListReducer, [])

        return <NotificationConfigListContext.Provider value={{state, dispatch}} >
            <Component {...props} />
        </NotificationConfigListContext.Provider>
    }
}